import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { TelegramAccount } from "@/lib/types";

async function fetchTelegramAccounts(): Promise<TelegramAccount[]> {
  const { data, error } = await supabase
    .from("telegram_accounts")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return (data ?? []) as TelegramAccount[];
}

export function useTelegramAccounts() {
  return useQuery<TelegramAccount[], Error>({
    queryKey: ["telegram-accounts"],
    queryFn: fetchTelegramAccounts,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
